import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import TextWithTip from "../../../../components/TextWithTip";
import { formatNumber, schoolMonths } from "../../shared/reportUtil";
import { AdminReportsResponse, ReportLevel } from "../adminReportsApiSlice";
import { reportSubLevelName } from "../adminReportsUtil";
import { DraftUsageRow } from "./adminUsageReportApiSlice";

export function DraftUsageTable(props: {
	className: string;
	level: ReportLevel;
	data: AdminReportsResponse<DraftUsageRow>;
	hideRows: boolean;
	setDistrictFilter: (districtId: number) => void;
	setSchoolFilter: (schoolId: number) => void;
}) {
	const hasData = props.data && props.data.rows.length > 0;

	function changeFilters(id: number) {
		if (props.level === ReportLevel.State) {
			props.setDistrictFilter(id);
		} else if (props.level === ReportLevel.District) {
			props.setSchoolFilter(id);
		}
	}

	const nameTemplate = (rowData: DraftUsageRow) => {
		return (
			<a
				className={`${props.level === ReportLevel.School ? "" : "link"}`}
				onClick={() => changeFilters(rowData.id)}>
				{rowData.name}
			</a>
		);
	};

	const teacherTemplate = (rowData: DraftUsageRow) => {
		return (
			<span>
				<TextWithTip uniqueName={`teachers-${rowData.id}`} text={rowData.teachers} />
			</span>
		);
	};

	const totalTemplate = (rowData: DraftUsageRow) => {
		return formatNumber(rowData.total);
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column
					footer="Total"
					footerClassName="font-medium !text-right"
					colSpan={props.level === ReportLevel.School ? 2 : 1}
				/>
				{schoolMonths.map((month) => (
					<Column
						key={month.value}
						footer={formatNumber(
							props.data.totals[
								month.value.toLowerCase() as keyof DraftUsageRow
							] as number
						)}
						footerClassName="font-medium !px-2"
					/>
				))}
				<Column
					footer={formatNumber(props.data.totals.total)}
					footerClassName="font-medium !px-2"
				/>
			</Row>
		</ColumnGroup>
	);

	return (
		<DataTable
			value={props.hideRows ? [] : props.data.rows}
			dataKey="id"
			loading={props.data.rows == undefined}
			emptyMessage="No results found"
			pt={{
				// Targets the container of the "No results found" message for hiding it
				emptyMessage: {
					style: { display: !props.hideRows ? "table-row" : "none" },
				},
			}}
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
			footerColumnGroup={hasData && footerGroup}>
			<Column
				header={reportSubLevelName(props.level)}
				body={nameTemplate}
				sortable
				sortField="name"></Column>
			{props.level === ReportLevel.School && (
				<Column
					header="Teacher(s)"
					body={teacherTemplate}
					className="!max-w-52"
					sortable
					sortField="teachers"></Column>
			)}
			{schoolMonths.map((month) => (
				<Column
					key={month.value}
					header={month.value}
					body={(rowData: DraftUsageRow) =>
						formatNumber(
							rowData[month.value.toLowerCase() as keyof DraftUsageRow] as number
						)
					}
					sortable
					sortField={month.value.toLowerCase()}
					headerClassName="!px-2"
					className="!px-2"
				/>
			))}
			<Column
				header="TOTAL"
				body={totalTemplate}
				sortable
				sortField="total"
				headerClassName="!px-2"
				className="!px-2"></Column>
		</DataTable>
	);
}
